export const register = {
  headline: 'Registrieren',
  inputLabels: {
    userName: 'Nutzername',
    password: 'Passwort',
    email: 'E-Mail',
    repeatPassword: 'Passwort wiederholen',
  },
  mainActions: {
    register: 'Registrieren',
  },
  messages: {
    confirmationEmailSent: 'Wir haben eine E-Mail an Sie versendet. Bitte klicken Sie dort auf den Link, um Ihre Registrierung zu bestätigen.',
    registrationCodeInvalid: 'Registrierung fehlgeschlagen. Dieses Konto existiert nicht oder kann derzeit nicht aktiviert werden.<br>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
    registrationSuccessful: '<h1 class="title is-2 has-text-grey">Vielen Dank für Ihre Registrierung. </h1><p class="title is-3 has-text-grey">Sie können sich nun einloggen.</p>',
    userNameInvalid: 'Ihr Nutzername darf kein <strong>@</strong> enthalten',
    userNameTooShort: 'Ihr Nutzername besteht aus mindestens 4 Zeichen',
    userNameAlreadyExists: 'Der Nutzername <span class="has-text-primary">{username}</span> ist bereits vergeben. Bitte wählen Sie einen anderen.',
    passwordMinLength: "Mindestens 8 Zeichen.",
    passwordMaxLength: "Höchstens 20 Zeichen."
  }
}
